import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../services/api';
import toast from 'react-hot-toast';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de un AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    verificarToken();
  }, []);

  const verificarToken = async () => {
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        setCargando(false);
        return;
      }

      const response = await api.get('/auth/verificar-token');
      
      if (response.data.success && response.data.valido && response.data.datos) {
        const datos = response.data.datos;
        setUsuario(datos);
        localStorage.setItem('usuario', JSON.stringify(datos));
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
      }
    } catch (error) {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
    } finally {
      setCargando(false);
    }
  };

  const login = async (credenciales) => {
    try {
      const response = await api.post('/auth/login', credenciales);
      
      if (response.data.success && response.data.datos) {
        const { token, usuario } = response.data.datos;
        
        localStorage.setItem('token', token);
        setUsuario(usuario);
        localStorage.setItem('usuario', JSON.stringify(usuario));
      } else {
        throw new Error(response.data.mensaje || 'Error en la respuesta del servidor');
      }
      
      toast.success('Inicio de sesión exitoso');
      return { exito: true };
    } catch (error) {
      const mensaje =
        error.response?.data?.mensaje ||
        error.response?.data?.error ||
        'Error al iniciar sesión';
      toast.error(mensaje);
      return { exito: false, error: mensaje };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    setUsuario(null);
    toast.success('Sesión cerrada');
  };

  const cambiarContrasena = async (datos) => {
    try {
      await api.post('/auth/cambiar-contrasena', datos);
      toast.success('Contraseña cambiada exitosamente');
      return { exito: true };
    } catch (error) {
      const mensaje = error.response?.data?.error || 'Error al cambiar contraseña';
      toast.error(mensaje);
      return { exito: false, error: mensaje };
    }
  };

  const valor = {
    usuario,
    cargando,
    login,
    logout,
    cambiarContrasena,
    verificarToken
  };

  return (
    <AuthContext.Provider value={valor}>
      {children}
    </AuthContext.Provider>
  );
}; 